import ServiceCRUD from '../../../../../../services/ServiceCRUD';
import { apiCase as http } from '../../../../../../http';

class ServiceClassificationService extends ServiceCRUD {
  constructor() {
    super('service-classification');
  }

  getAllServiceClassificationByMatrixSLAId(slaMatrixId) {
    return http.get(`${this.path}/matrix/${slaMatrixId}`);
  }

  getServiceClassificationById(id) {
    return http.get(`${this.path}/${id}`);
  }

  createServiceClassification(data, usrLogin) {
    return http.post(this.path, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  updateServiceClassification(id, data, usrLogin) {
    return http.put(`${this.path}/${id}`, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  enableDisableServiceClassification(id, data, usrLogin) {
    return http.put(`${this.path}/${id}/enable-disable`, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  getQuantityServiceClassificationByMatrixSLAId(slaMatrixId) {
    return http.get(`${this.path}/quantity-by-matrix/${slaMatrixId}`);
  }

  getServiceClassification(queryParams) {
    return http.get(`${this.path}`, {
      params: queryParams
    });
  }

  getServiceClassificationByReasonIdAndRecordType(reasonId) {
    return http.get(`${this.path}/reason/${reasonId}/record-types`);
  }

  getServiceClassificationNameByReasondMatrixId(matrixId, reasonId) {
    return http.get(
      `${this.path}/name-by-reason-subreason?matrixId=${matrixId}&reasonId=${reasonId}`
    );
  }

  getServiceClassificationTimeBySubreasonMatrixId(
    matrixId,
    reasonId,
    subreasonId
  ) {
    return http.get(
      `${this.path}/name-by-reason-subreason?matrixId=${matrixId}&reasonId=${reasonId}&subreasonId=${subreasonId}`
    );
  }
}

export default new ServiceClassificationService();
